<template>
    <div class="button-cell-wrapper">
        <!-- Cell with tooltip -->
        <tooltips-generic v-if="value.tooltipText" applyPositionFixed :description="value.tooltipText">
            <template v-slot:slotElement>
                <component
                buttonSize="small"
                :is="buttonComponent"
                :icon="value.iconName || value"
                :disabled="value.disabled"
                @clicked="emit('buttonClicked')"/>
            </template>
        </tooltips-generic>
        <!-- Button without tooltip -->
        <component v-else
        buttonSize="small"
        :is="buttonComponent"
        :icon="value.iconName || value"
        :disabled="value.disabled"
        @clicked="emit('buttonClicked')"/>
    </div>
</template>

<script setup>
import TooltipsGeneric from '@/components/generic/tooltips/Generic'
/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/* Emmitters */
const emit = defineEmits(['buttonClicked'])

/** Props received:
@value {String} icon name
or
@value {Object} when we need classes or variants, object with:
	iconName {String} icon to be displayed
	variant {String} button to use
*/
const props = defineProps({
	value: [String, Object]
})

/* Computed for icon */
const buttonComponent = computed(() => {
    if (!props.value.variant) return defineAsyncComponent(() => import('@/components/generic/buttons/Quaternary'))

    return defineAsyncComponent(() => import('@/components/generic/buttons/' + componentMapping[props.value.variant]))
})

/** maps the list of components that are used as cell */
const componentMapping = {
	primary: 'Primary',
    secondary: 'Secondary',
    tertiary: 'Tertiary',
    quaternary: 'Quaternary'
}
</script>

<style lang="scss" scoped>
.button-cell-wrapper {
    width: 100%;
    height: 100%;
    position: relative;

	display: flex;
	flex-shrink: 0;
	flex-direction: row;
	align-items: center;
	justify-content: center;

    .tooltip-container {
        height: 40px;
        align-self: unset;
    }
}
</style>
